import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ListShip from '../../../components/ProjectsAndVessels/Projects/assignShip'
import constant from '../../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_assign_vessels, v3_unassigned_vessels } from '../../../actions/v3/projectAndVessel'
import { replacePageState } from '../../../utils';
const List = (props) => {

    const location = useLocation();
    const { page, data: encryptedData } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        v3_unassigned_vessels(currentPage, limit, JSON.parse(atob(encryptedData))['ID']).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.assignVesselsToProject.url, {
                    page: currentPage,
                    data: encryptedData
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    const onSave = (payload) => {
        v3_assign_vessels({ payload }, JSON.parse(atob(encryptedData))['ID']).then((res) => {
            if (res.status) {
                setData(res.result);
                props.history.push(constant.Authedcomponent.listProject.url);
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout
            title={'Assign Vessel'}
        >
            {data && <ListShip
                onSave={onSave}
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List